import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ServiceTemplateScheduleOccurrenceRow } from "../serviceTemplateScheduleOccurrencesViewConfig";

export const ServiceTemplateScheduleOccurrenceIndexCell = memo(
    ({
        getValue,
    }: CellContext<
        ViewTableFeatures,
        ServiceTemplateScheduleOccurrenceRow,
        number
    >) => (
        <ViewTableCell>
            <span>{getValue() + 1}</span>
        </ViewTableCell>
    ),
);

ServiceTemplateScheduleOccurrenceIndexCell.displayName =
    "ServiceTemplateScheduleOccurrenceIndexCell";
